import { render, staticRenderFns } from "./DeleteLocationPopup.vue?vue&type=template&id=5877cd08&scoped=true&"
import script from "./DeleteLocationPopup.vue?vue&type=script&lang=ts&"
export * from "./DeleteLocationPopup.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteLocationPopup.vue?vue&type=style&index=0&id=5877cd08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5877cd08",
  null
  
)

export default component.exports